import { render } from "./ProfPepOverlay.vue?vue&type=template&id=91a7efb8&scoped=true"
import script from "./ProfPepOverlay.vue?vue&type=script&lang=js"
export * from "./ProfPepOverlay.vue?vue&type=script&lang=js"

import "./ProfPepOverlay.vue?vue&type=style&index=0&id=91a7efb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91a7efb8"]])

export default __exports__